import type { User } from '../types'

/** E-maily, které se nikdy nezobrazují ve výběrových seznamech uživatelů. */
export const EXCLUDED_USER_EMAILS = ['sirotinushkadvd@gmail.com'] as const

export function normalizeUserEmail(email: string): string {
  return email.trim().toLowerCase()
}

export function isExcludedFromUserLists(email: string): boolean {
  const n = normalizeUserEmail(email)
  return (EXCLUDED_USER_EMAILS as readonly string[]).includes(n)
}

/** Zaměstnanec školy (ne student, ne vyloučený e-mail). */
export function isSchoolEmployeeUser(user: Pick<User, 'email' | 'user_type'>): boolean {
  const email = normalizeUserEmail(user.email || '')
  if (!email || isExcludedFromUserLists(email)) return false
  const ut = user.user_type || ''
  if (ut === 'student' || email.endsWith('@student.iss-cheb.cz')) return false
  if (ut === 'employee') return true
  if (email.endsWith('@iss-cheb.cz')) return true
  return false
}

export function filterUsersForPicker(
  users: User[],
  options?: { employeesOnly?: boolean },
): User[] {
  let list = users.filter((u) => !isExcludedFromUserLists(u.email))
  if (options?.employeesOnly) {
    list = list.filter(isSchoolEmployeeUser)
  }
  return list
}
